
























































































































































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class SalesOrderView extends Vue {
  public createPurchaseOrder = Components.CreatePurchaseOrder;
  public updateDeliveryDate = Components.UpdateDeliveryDate;
  public shippingInstructionDialog = Components.ShippingInstruction;
  public items: Common.SalesOrder[] = new Array(0);
  public params: Common.OrderQuery = new Common.OrderQuery(Common.SalesPurchaseFlags.Sales);
  public importQuery = new Common.OrderImportQuery('受注',Common.SalesPurchaseFlags.Sales);
  public exportQuery = new Common.OrderExportQuery('受注', this.params,Common.SalesPurchaseFlags.Sales);
  public calcUtil: Common.CalcUtil = new Common.CalcUtil();
  public usedTypes = Common.UsedTypes;  
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'orderNo', text: '受注番号' },
    { value: 'orderDate', text: '受注日' },
    { value: 'counterpart', text: '得意先' },
    { value: 'requestDate', text: '希望納期' },
    { value: 'receiver', text: '納入先' },
    { value: 'projectItem', text: '案件' },      
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'refNo', text: '受注管理番号' },
    { value: 'customerOrderNo', text: '顧客注文番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true, true, true];
  public tabVisiblesOnInsert: Array<boolean> = [true, true, true, true, true, false, false, false, false];  
  public tenantSettings: Common.TenantSettings = null;
  public hasLicenseCurrency: boolean = false;
  public hasLicenseExport: boolean = false;
  @Prop() public orderNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor;  

  public voucherTypes = Common.voucherTypes;
  //伝票インポート用
  public salesOrderImportQuery = new Common.VoucherImportQuery("SalesOrderImportQuery", Common.SalesOrder);

  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');
  public dlgConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');//明細一括入力
  public dlgSkuConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');//SKU一括入力
  public dlgRegularlyDeliveryConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'col');//定期出荷入力

  // 入金情報タブ可変表示用プロパティ
  public paymentTabCaptions = new Array();
  public paymentTabWidths = new Array();
  public paymentTabSlots = new Array();
  public paymentTabGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('状態', 120),
      new Common.GridItemConfiguration('入金伝票番号', 150),
      new Common.GridItemConfiguration('入金日', 120),
    ],
    3, // 入金日の次を可変表示項目の挿入位置に指定
    'col'
  );
  // ライセンスによって表示の切り替わる項目
  public paymentTabVariableGridItems1: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('入金通貨', 150),
    new Common.GridItemConfiguration('入金レート', 150)
  ];
  public paymentTabVariableGridItems2: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('入金金額', 150)
  ];
  public paymentTabVariableGridItems3: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('入金計上額', 150)
  ];

  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    this.hasLicenseExport = this.$api.hasLicense(Common.licenseFlags.export);
    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 150),
      new Common.GridItemConfiguration('受注番号', 150),
      new Common.GridItemConfiguration('ワークフロー', 250),
      new Common.GridItemConfiguration('受注日', 120),
      new Common.GridItemConfiguration('得意先', 200),
      new Common.GridItemConfiguration('希望納期', 120),
      new Common.GridItemConfiguration('納入先', 200),
      new Common.GridItemConfiguration('納入先名称', 200),
      new Common.GridItemConfiguration('取引通貨', 150,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('受注管理番号', 120),
      new Common.GridItemConfiguration('顧客注文番号', 150),
      new Common.GridItemConfiguration('案件', 150),            
      new Common.GridItemConfiguration('部門', 120),
      new Common.GridItemConfiguration('担当者', 120),
      new Common.GridItemConfiguration('受注金額', 120),
      new Common.GridItemConfiguration('税計算区分', 120),
      new Common.GridItemConfiguration('前受金請求額', 150,this.hasLicenseExport),
      new Common.GridItemConfiguration('前受金請求残高', 150,this.hasLicenseExport),
      new Common.GridItemConfiguration('前受金残高', 120,this.hasLicenseExport),
      new Common.GridItemConfiguration('前受金消込額(確定待ち)',180,this.hasLicenseExport),
      new Common.GridItemConfiguration('入金予定日', 120,this.hasLicenseExport),
      new Common.GridItemConfiguration('インポート番号', 100),       
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 120),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 120)
    );
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    // インポート・エクスポートの制御
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.importQuery.hasLicenseExport = this.hasLicenseExport;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseExport = this.hasLicenseExport;
    // タブ表示の制御
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction); // 予備項目タブ
    this.$set(this.tabVisiblesOnInsert, 4, this.$api.useStockFunction); // 予備項目タブ
    this.$set(this.tabVisibles, 5, this.hasLicenseExport); // 入金情報タブ
    this.paymentTabVariableGridItems1.forEach(item => item.IsVisible = this.hasLicenseCurrency);
    this.paymentTabVariableGridItems3.forEach(item => item.IsVisible = this.hasLicenseCurrency);
    // 入金情報タブの表示項目制御
    this.paymentTabVariableGridItems1 = this.paymentTabVariableGridItems1.concat(this.paymentTabVariableGridItems2);
    this.paymentTabVariableGridItems1 = this.paymentTabVariableGridItems1.concat(this.paymentTabVariableGridItems3);
    this.paymentTabGridConfig.setVariableItems(this.paymentTabVariableGridItems1);
    this.paymentTabCaptions = this.paymentTabGridConfig.gridCaptions;
    this.paymentTabWidths = this.paymentTabGridConfig.gridWidths;
    this.paymentTabSlots = this.paymentTabGridConfig.gridSlots;
    //明細一括入力用のグリッド
    // this.dlgConfig.setGridItemsFromCaptions(
    //   ['商品','商品名称','SKU',  '単位', '受注数量', '単価', '税区分', '発注先', '回答納期', '出荷予定日'],
    //   [250, 150, 200, 120, 130, 130, 120, 200, 130, 130]
    // );
    // this.dlgConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,false,true,false));//商品識別情報+商品メモ+受発注メモ

    //SKU一括入力用のグリッド
    this.dlgSkuConfig.setGridItemsFromCaptions(
      ['SKU', '受注数量', '単価'],
      [150, 150, 150]
    );
    this.dlgSkuConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,false,true,false));//商品識別情報+商品メモ+受発注メモ

    //定期出荷入力用のグリッド
    this.dlgRegularlyDeliveryConfig.setGridItemsFromCaptions(
      ['商品', 'SKU', '単位', '定期数量',],
      [250, 150, 150, 150]
    );
    this.dlgRegularlyDeliveryConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,true,true,false));//商品識別情報+商品メモ+受発注メモ

    // 検索条件を設定する
    if(this.orderNo) {
      this.params.orderNo = this.orderNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
    }
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
    // 子画面用ワークフロー情報をロードする
    this.$api.formatter.ensureListLoaded('workflow_purchaseOrder');
    this.$api.formatter.ensureListLoaded('workflow_salesDelivery');
    this.$api.formatter.ensureListLoaded('workflow_receivePayment');
    var workflows = this.$api.formatter.getOptions('workflow_salesDelivery');
    this.regdWorkflowRequired = workflows.length > 0;
  }

  public async onCreate(obj: Common.SalesOrder) {
    const workflows = this.$api.formatter.getOptions('workflow_salesOrder');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.pic = this.$api.auth.userId;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
      //受注明細タブのリロード
       (this.$refs.salesOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();           
  }

  // 状態から編集可能か判別する
  public isEditable(state: Common.OrderStatus):boolean{
    if(state == Common.OrderStatus.SalesOrderSaving) return true;
    if(state == Common.OrderStatus.SalesOrderWaiting) return true;
    return false;
  }
  // 完了以外で編集可能
  public isEditableNoComplete(state: Common.OrderStatus):boolean{
    if(state == Common.OrderStatus.SalesOrderCompleted) return false;
    return true;
  }

  public selectedSalesOrderItems(){
    //明細処理でorderのロード状態が十分ではない場合があるため、送信する前にorderをセットする
    var items =  (this.$refs.salesOrderItems as Components.GrdVoucherItem).selectedItems as Common.OrderItem[];
    items.forEach(obj =>obj.order = (this.$refs.mainList as Components.ListView).selected as Common.Order);
    return items;
  }
  public allSalesOrderItems(){
    //明細処理でorderのロード状態が十分ではない場合があるため、送信する前にorderをセットする
    var items =  (this.$refs.salesOrderItems as Components.GrdVoucherItem).items as Common.OrderItem[];
    items.forEach(obj =>obj.order = (this.$refs.mainList as Components.ListView).selected as Common.Order);
    return items;
  }  
  // 得意先変更時に得意先の通貨を設定する
  public onChangeCustomer(item: Common.Order, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.currencyCode = item.counterpart ? item.counterpart.currencyCode : '';
    if (item.counterpart && item.counterpart.salesPerson) item.pic = item.counterpart.salesPerson;
    item.onChangeCounterpart()
  }

  // 納入先変更時に納入先詳細を設定する
  public onChangeReceiver(item: Common.Order, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.onChangeReceiver();
  }

  // 一覧でチェックされている受注伝票
  public checkedOrders: Array<Common.Order>= new Array(0);
  public getCheckedOrders(){
    this.checkedOrders = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        obj.writeoffAmountFC = 0;
        this.checkedOrders.push(obj);
      }
    });
  }

  // 一覧選択時に明細表示ボタンを非活化状態・入金情報タブを更新
  public onSelectedMain(index: number, selected: Common.Order) {
    // 明細表示ボタンの非活化状態を更新
    this.updateDisabledShowItemButton(selected);
    
    // 発注明細表示・出荷明細表示ボタンの非活化状態を更新
    this.disabledShowReferenceItemButton
      = selected.state != Common.OrderStatus.SalesOrderItemsOperating
      && selected.state != Common.OrderStatus.SalesOrderCompleted;

    //入金情報タブを更新
    this.totalPaymentAmountFC = 0;
    this.totalPendingAmountFC = 0;
    this.paymentJournals = new Array(0);
    if(index >= 0) this.refreshPaymentList();
  }

  // 入金処理用プロパティ
  public rdSegment: Common.Segment = null;
  public rdPic: string = '';
  public rdWorkflowId: number = 0;
  public rdCounterpart: Common.Counterpart = null;
  public rdCurrencyCode: string = '';
  public rdReceiptDate: Date = null;
  public rdBankAccount: Common.BankAccount = null;
  public rdExchageRate: number = 0;
  public get rdReceiptAmountFC(): number { return this.rdSettlementAmountFC - this.rdCommissionAmountFC; };
  public rdCommissionAmountFC: number = 0;
  public rdCommissionTaxFlag: boolean = false;
  public get rdSettlementAmountFC(): number {
    if(this.checkedOrders.length == 0) return 0;
    return this.checkedOrders.map(obj => obj.writeoffAmountFC).reduce((total, value) =>(total + value));
  };
  public rdDecimal: number = 0;

  // 入金処理ダイアログの表示
  public showAdvanceReceiptDialog() {
    this.getCheckedOrders();

    // ダイアログ表示前バリデーション
    if(this.checkedOrders.length == 0){
      this.$api.modal.show('', '受注伝票を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrders.filter(order=> this.checkedOrders[0].counterpart.id != order.counterpart.id).length > 0){
      this.$api.modal.show('', '同一得意先の受注伝票を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrders.filter(order=> this.checkedOrders[0].currencyCode != order.currencyCode).length > 0){
      this.$api.modal.show('', '同一取引通貨の受注伝票を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrders.filter(order=> this.checkedOrders[0].segmentId != order.segmentId).length > 0){
      this.$api.modal.show('', '同一部門の受注伝票を選択して下さい。', true, null);
      return;
    }    
    if(this.checkedOrders.filter(order=> (order.state & (Common.OrderStatus.SalesOrderReceiptWaiting | Common.OrderStatus.SalesOrderPartialReceiptWaiting)) <= Common.OrderItemStatus.PurchaseOrder).length > 0){
      this.$api.modal.show('', '前受金入金待ち、または前受金一部入金の受注伝票を選択して下さい。', true, null);
      return;
    }

    // 入力項目の初期化
    this.rdSegment = this.checkedOrders[0].segment; //発生部門をセット(非表示)
    this.rdPic = this.$api.auth.userId;
    this.rdWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_receivePayment');
    this.rdCounterpart = this.checkedOrders[0].counterpart;
    this.rdCurrencyCode = this.checkedOrders[0].currencyCode;
    this.rdReceiptDate = this.checkedOrders.map(order => order.dueDate).reduce((min, value) => min = (min == null || min > value) ? value : min);
    this.rdExchageRate = 1;
    this.rdCommissionAmountFC = 0;
    this.rdCommissionTaxFlag = true; // 販売管理では課税固定
    this.onChangeRdCurrency();
    this.getBankAccount();

    this.rdDecimal = 0;
    const obj = this.$api.currencies.filter(obj => obj.value == this.rdCurrencyCode);
    if (obj.length > 0) this.rdDecimal = Number(obj[0].text);

    // ダイアログの表示
    (this.$refs.advanceReceiptDialog as Components.ListDialog).items = this.checkedOrders;
    (this.$refs.advanceReceiptDialog as Components.ListDialog).showDialog();
  }

  public async onChangeRdCurrency(){
    const query = new Common.GetExchangeRateQuery();
    query.currency = this.rdCurrencyCode;
    query.startDate = this.rdReceiptDate;
    this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      this.rdExchageRate = exchangeRate ? exchangeRate.rate : 1;
    });
  }

  public async getBankAccount(){
    const query = new Common.GetBankAccount();
    query.currencyCode = this.rdCurrencyCode;
    this.$api.execute(query).then(res => {
      this.rdBankAccount = res as Common.BankAccount;
    });
  }

  // 入金処理の実行
  public async submitAdvanceReceipt(list: Array<Common.Order>)
  {
    // クエリの設定
    var query = new Common.AdvanceReceiptQuery();
    query.segment = this.rdSegment;
    query.pic = this.rdPic;
    query.counterpart = this.rdCounterpart;
    query.currencyCode = this.rdCurrencyCode;
    query.receiptDate = this.rdReceiptDate;
    query.bankAccount = this.rdBankAccount;
    query.exchangeRate = this.rdExchageRate;
    query.commissionAmountFC = this.rdCommissionAmountFC;
    query.settlementAmountFC = this.rdSettlementAmountFC;
    query.commissionTaxFlag = this.rdCommissionTaxFlag;
    query.orders = list;
    query.workflowId = this.rdWorkflowId;
    
    // 入金処理後、入金一覧へ画面遷移
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/cash/Deposit?paymentNo={0}',(res as Common.Payment).paymentNo));      
    // });
    return this.$api.execute(query,true).then(res => {
      //リストリロード
      (this.$refs.mainList as Components.ListView).reload();
      var payment = res as Common.Payment;
      //入金明細タブのリロード
      this.refreshPaymentList();
      this.$api.modal.show('処理結果','以下の入金伝票が作成されました。',true,null,[new Common.ModalLink(payment.paymentNo, String.format('/cash/Deposit?paymentNo={0}',payment.paymentNo))]);
      return true;
    }).catch(()=>{return false;});    
  }

  // 明細表示ボタンの非活性判別
  public disabledShowItemButton: boolean = true;
  public  updateDisabledShowItemButton(order:Common.Order){
    this.disabledShowItemButton = true;
    
    var query = new Common.GetOrderItemQuery();
    query.orderNo = order.orderNo;
    this.$api.execute(query).then(res => {
      this.disabledShowItemButton = res.length == 0;
    });
  }

  // 明細一括入力・SKU一括入力ボタンの非活性判別
  public  disabledAddItemButton(order:Common.SalesOrder):boolean{
    // 2020.08.13 非活性条件の変更 バグ422
    // return order.state >= Common.OrderStatus.SalesOrderItemsOperateWaiting;
    // 2023.10.17 受注確定待ちを活性に変更
    return order.state > Common.OrderStatus.SalesOrderWaiting;
  }
  // 出荷指示・発注処理ボタンの非活性判別
  public  disabledOrderItemFuncButton(order:Common.SalesOrder):boolean{
    return order.state < Common.OrderStatus.SalesOrderItemsOperateWaiting || order.state == Common.OrderStatus.SalesOrderCompleted;
  }

  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.SalesOrder){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.SalesOrder, sourceNo : item.orderNo},this.$el);
  }

  // 受注明細一覧を表示
  public showSalesOrderItems() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    let routeData = this.$router.resolve(String.format('/sales/SalesOrderItem?orderNo={0}',obj.orderNo));
    window.open(routeData.href, '_blank');
  }

  // 発注明細表示・出荷明細表示ボタンの非活性判別
  public disabledShowReferenceItemButton: boolean = true;


  // 発注明細一覧を表示
  public showPurchaseOrderItems(event :any) {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    let routeData = this.$router.resolve(String.format('/purchase/PurchaseOrderItem?salesOrderItemNo={0}',obj.orderNo));
    window.open(routeData.href, '_blank');
  }

  // 出荷明細一覧を表示
  public showSalesDeliveryItems() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    let routeData = this.$router.resolve(String.format('/sales/SalesDeliveryItem?orderItemNo={0}',obj.orderNo));
    window.open(routeData.href, '_blank');
  }
  public createDelivery(){
    // var count = this.selectedSalesOrderItems.length;
  }

  public subscriptionStartDate: Date = null;
  public subscriptionEndDate: Date = null;  
  public isSubscription: boolean = false;
  // 明細一括入力ダイアログを表示
  public showBundleAddOrderItemDialog() {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    
    // 新規の場合、編集中のものを設定
    if(parent.counterpart == null){
      this.$api.modal.show('', '得意先を指定してください。', true, null);
      return ;
    }
    this.isSubscription = parent.isSubscription;
    //サブスクリプション用の契約開始日・完了日をセットする
    this.subscriptionStartDate = new Date().getBeginDate();
    this.subscriptionEndDate = new Date().getBeginDate();
    this.subscriptionEndDate.setMonth(this.subscriptionEndDate.getMonth() + 1);
    this.subscriptionEndDate.setDate(0);

    //グリッド設定
    this.dlgConfig = new Common.GridConfiguration([],0, 'col');

    this.dlgConfig.setGridItems(
      new Common.GridItemConfiguration('商品', 250),
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('SKU', 200,this.$api.useStockFunction),
      new Common.GridItemConfiguration('単位', 120),
      new Common.GridItemConfiguration('受注数量', 130,parent.isSubscription == false),
      new Common.GridItemConfiguration('月次数量', 130,parent.isSubscription == true),      
      new Common.GridItemConfiguration('単価', 130),
      new Common.GridItemConfiguration('税区分', 120),
      new Common.GridItemConfiguration('発注先', 200,parent.isSubscription == false),
      new Common.GridItemConfiguration('回答納期', 130,parent.isSubscription == false),
      new Common.GridItemConfiguration('出荷予定日', 130, parent.isSubscription == false)
    );    

    this.dlgConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,false,true,false));//商品識別情報+商品メモ+受発注メモ

    var items = new Array();
    var instance = new Common.SalesOrderItem();
    instance.taxCode = parent.counterpart.taxCode;
    items.push(instance);
    (this.$refs.bundleAddOrderItemDialog as Components.ListDialog).items = items;
    (this.$refs.bundleAddOrderItemDialog as Components.ListDialog).showDialog();
  }

  //明細一括入力ダイアログの予備項目の活性・非活性を切り替える
  public isEditable2(usedType: Common.UsedTypes){
    //商品識別情報,受発注メモは活性。それ以外は非活性
        if(usedType == Common.UsedTypes.CommodityAttribute ||usedType == Common.UsedTypes.OrderMemo)  return true;else return false;
  }

  // 商品変更時に商品名・単価・税区分・予備項目を設定する
  public onChangeCommodity(item:Common.OrderItem){
    item.onChangeCommodity(this.tenantSettings);
    this.getPriceAndTaxCode(item);
  }

  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.SalesOrderItem){
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.Order;
    this.$api.execute(new Common.OrderGetItemPriceQuery(parent, item)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    });
  }

  //行追加時に税区分の初期値を設定
  public async onItemCreate(obj:Common.SalesOrderItem){
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    obj.taxCode = parent.counterpart.taxCode;
    return Promise.resolve(obj);
  }

public submitBundleAddOrderItemRun(){
  const items = (this.$refs.salesOrderItems as Components.GrdVoucherItem).items;
  if(items.length > 0) this.submitBundleAddOrderItem(items);
}
  // 明細一括入力の実行
  public async submitBundleAddOrderItem(list: Array<Common.SalesOrderItem>) {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    var items = new Array();
    await list.forEach(async obj => {
      obj.order = parent;
      obj.purchasePrice = obj.commodity.purchasePrice;
      //サブスクリプション開始日・完了日を設定
      if (parent.isSubscription) {
        obj.subscriptionStartDate = this.subscriptionStartDate;
        obj.subscriptionEndDate = this.subscriptionEndDate;
        obj.answerDeliveryDate = null;
        obj.scheduledDeliveryDate = null;
        obj.supplier = null;
      }
      items.push(obj);
    });
    //新規追加時は明細を一時的に保持する
    if((this.$refs.mainList as Components.ListView).isInsertMode){
     (this.$refs.salesOrderItems as Components.GrdVoucherItem).mergeItems(items);
      return true;
    }
    var query = new Common.BundleAddOrderItemQuery(Common.SalesPurchaseFlags.Sales);
    query.orderItems = items;
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/sales/SalesOrderItem?orderNo={0}',parent.orderNo));
    // });    
    return this.$api.execute(query).then(res => {
      //受注金額が更新されるのでリストを更新する
       (this.$refs.mainList as Components.ListView).onSubmit(res).finally(()=>{
        //受注明細タブのリロード
        (this.$refs.salesOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();      
        //事後アクションダイアログを表示するためコメントアウト
        //this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      }); 
      return true;
    }).catch(()=>{return false;});
  }

  // SKU一括入力プロパティ
  public sbaoiHeaderItem: Common.SalesOrderItem = new Common.SalesOrderItem();
  public scheduledDeliveryDateSKU: Date = new Date();
  // SKU一括入力ダイアログを表示
  public showSkuBundleAddOrderItem() {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;    
    this.sbaoiHeaderItem = new Common.SalesOrderItem();
    this.sbaoiHeaderItem.taxCode = parent.counterpart.taxCode; //税区分初期値をセット
    this.scheduledDeliveryDateSKU = new Date();
    (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items = new Array();
    (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).showDialog();
  }
  
  // 定期出荷入力プロパティ
  public regdOrderItems: Common.SalesOrderItem = new Common.SalesOrderItem();
  public regdWorkflowRequired: boolean = false;
  public regdWorkflowId: number = 0;
  public regdPic: string = '';
  public regdRefNo: string = '';
  public regdRegularlyStartMonth: Date = null;
  public regdRegularlyDate: number = 0;
  public regdRegularlySycle: number = 0;
  public regdRegularlyTimes: number = 0;
  public buttonNames: Array<string> = null;
  public buttonIndexIdArray: Array<{index:number,actionId:number}> =null;
  public roundDown: Common.RoundTypes = Common.RoundTypes.RoundDown;  // 定期出荷可能数量計算用
  // 定期出荷入力ダイアログを表示
  public showRegularlyDeliveryDialog() {

    this.getCheckedOrders();
    if(this.checkedOrders.length == 0){
      this.$api.modal.show('', '受注伝票を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrders.length > 1){
      this.$api.modal.show('', '単一の受注伝票を選択してください', true, null);
      return ;
    }
    if(this.checkedOrders[0].state < Common.OrderStatus.SalesOrderItemsOperateWaiting){
      this.$api.modal.show('', '「出荷処理待ち」か「出荷処理中」の受注伝票を選択してください。', true, null);
      return ;
    }
    
    var items:Array<Common.SalesOrderItem>;
    items = new Array();
    this.allSalesOrderItems().forEach(item => {
      if(item.commodity.isNoStock == true && item.backSalesOrderQuantity > 0) items.push(item);
    });
    if(items.length<1){
      this.$api.modal.show('', '定期出荷できる明細がありません。棚卸対象外の商品で受注残数量のある明細がある受注伝票を選択して下さい。', true, null);
      return ;
    }

    this.regdWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_salesDelivery');
    this.onChangeregdWorkflow();
    this.regdPic = this.$api.auth.userId;
    this.regdOrderItems = new Common.SalesOrderItem();
    (this.$refs.regularlyDeliveryDialog as Components.ListDialog).items = items;
    (this.$refs.regularlyDeliveryDialog as Components.ListDialog).showDialog();
  }
  public submitRegularlyDeliveryQuery(list: Array<Common.OrderItem>, index:number){
    var query: Common.RegularlyDeliveryQuery =new Common.RegularlyDeliveryQuery();
    query.salesOrderItems = list;
    query.workflowId = this.regdWorkflowId;
    query.pic = this.regdPic;
    query.deliveryRefNo = this.regdRefNo;
    query.regularlyStartMonth = this.regdRegularlyStartMonth;
    query.regularlyDate = this.regdRegularlyDate;
    query.regularlySycle = this.regdRegularlySycle;
    query.regularlyTimes = this.regdRegularlyTimes;
    query.actionId = this.buttonIndexIdArray.filter(obj => obj.index==index)[0].actionId;

    (this.$refs.regularlyDeliveryDialog as Components.ListDialog).closeDialog();
    return this.$api.execute(query,true).then(res => {
      // 画面を更新
      (this.$refs.mainList as Components.ListView).reload();
      //トライアル中はロードマップを更新
      if(this.$api.license.isTrial) this.$api.updateRoadmapRatio();     
      var deliveries = res as Common.Delivery[];
      var links = deliveries.map(delivery=>new Common.ModalLink(delivery.deliveryNo,String.format('/sales/SalesDelivery?deliveryNo={0}',delivery.deliveryNo)));
      var dialogMessage = '以下の出荷伝票が作成されました。';
      if(deliveries.length==1){
        this.$api.modal.show('処理結果',dialogMessage,false,()=>{
          var url = String.format('/sales/SalesDelivery?deliveryNo={0}',deliveries[0].deliveryNo);
          if (url){ this.$router.push(url);}
        },links,'伝票に移動する','閉じる');
      }else{
        this.$api.modal.show('処理結果',dialogMessage,true,null,links,'閉じる');
      }
      return true;
    }).catch(()=>{
      return false;}); 
  }

  public onChangeregdWorkflow(){
    this.buttonNames=new Array();
    this.buttonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.buttonIndexIdArray.push({index:buttonIndex++,actionId:0})
    this.buttonNames.push("出荷保存");
    if(this.regdWorkflowId!=0)
    {
      var actions = this.$api.perms.getWorkflowActionsHasPermission('salesDelivery', this.regdWorkflowId, Common.DeliveryStatus.SalesDeliveryPostWaiting);
      actions.forEach(action => {
        this.buttonNames.push(action.actionName);
        this.buttonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }
  }

  // 商品変更時に連動更新項目をサーバー側で行いそれを設定する
  public onChangeCommodity2(){
    // 明細を初期化
    (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items = new Array(0);
    
    // 商品に連動する項目の設定
    this.sbaoiHeaderItem.onChangeCommodity(this.tenantSettings);
    this.getPriceAndTaxCode(this.sbaoiHeaderItem);
    
    if(this.sbaoiHeaderItem != null && this.sbaoiHeaderItem.commodity != null){
      // 選択した商品のSKUを一括取得
      var query = new Common.SKUMasterQuery();
      query.commodityId = this.sbaoiHeaderItem.commodity.id;
      this.$api.execute(query).then(res => {
        // SKUごとに明細を作成
        for(var sku of res.result){
          var item = (this.sbaoiHeaderItem as Common.StateObject2).copy();
          item.sku = sku as Common.SKU;
          this.getPriceAndTaxCode(item);
          (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items.push(item);
        }
      });
      // 明細を更新
      (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).$forceUpdate();
    }
  }

  // 単位変更時に単価・税区分を取得する
  public onChangePackage(){
    for(var item of (this.$refs.skuBundleAddOrderItemDialog as Components.ListDialog).items){
      item.package = this.sbaoiHeaderItem.package;
      this.getPriceAndTaxCode(item);
    }
  }

  // SKU一括入力の実行
  public async submitSkuBundleAddOrderItemQuery(list: Array<Common.SalesOrderItem>) {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    var items = new Array();
    for(var obj of list){
      if(obj.quantity == 0) continue;
      obj.order = parent;
      // ダイアログのヘッダ部の内容を設定
      obj.commodity = this.sbaoiHeaderItem.commodity;
      obj.commodityName = this.sbaoiHeaderItem.commodityName;
      // obj.package = this.sbaoiHeaderItem.package;
      obj.uom2 = this.sbaoiHeaderItem.uom2;
      obj.taxCode = this.sbaoiHeaderItem.taxCode;
      obj.supplier = this.sbaoiHeaderItem.supplier;
      obj.scheduledDeliveryDate = this.scheduledDeliveryDateSKU;
      items.push(obj);
    }

    if(items.length == 0){
      return this.$api.modal.showDialog('', 'いずれかの行で受注数量を指定して下さい。').then(()=>false);      
    }
    //新規追加時は明細を一時的に保持する
    if((this.$refs.mainList as Components.ListView).isInsertMode){
     (this.$refs.salesOrderItems as Components.GrdVoucherItem).mergeItems(items);
      return true;
    }
    var query = new Common.BundleAddOrderItemQuery(Common.SalesPurchaseFlags.Sales);
    query.orderItems = items;
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/sales/SalesOrderItem?orderNo={0}',parent.orderNo));
    // });
    return this.$api.execute(query).then(res => {
      //受注金額が更新されるのでリストを更新する
       (this.$refs.mainList as Components.ListView).onSubmit(res);
      //受注明細タブのリロード
       (this.$refs.salesOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();       
      this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      return true;
    }).catch(()=>{return false;});    
  }

  // 入金情報タブ更新用プロパティ
  public isLoading:boolean = false;
  public totalPaymentAmountFC:number = 0;
  public totalPaymentAmount:number = 0;
  public totalPendingAmountFC:number = 0;
  public paymentJournals: Common.TransferJournal[]= new Array(0);

  // 入金情報タブを更新
  public refreshPaymentList(){
    this.isLoading = true;
    var totalWriteoffAmountFC = 0;
    var totalWriteoffAmount = 0;
    var totalWriteoffPendingAmountFC = 0;
    // クエリの設定
    var query = new Common.PaymentJournalQuery();
    query.voucherNo = (this.$refs.mainList as Components.ListView).selected.orderNo;
    query.isSend = false;

    // サーバーから入金情報を取得する
    this.$api.execute(query).then(res => {
      if((this.$refs.mainList as Components.ListView).isInsertMode == false){
        res = res as Common.LoadResult;
        this.paymentJournals = res.result;
        this.paymentJournals.forEach((obj, index) => {
          if (obj.isPosted) {
            totalWriteoffAmountFC += obj.amountFC;
            totalWriteoffAmount += obj.debitAmount;
            obj.state = Common.PaymentStatus.ReceiptCompleted;
          } else {
            totalWriteoffPendingAmountFC += obj.amountFC;
            obj.state = Common.PaymentStatus.ReceiptPostWaiting;            
          }
        });
      }
    }).finally(()=>{
      this.isLoading = false;
      this.totalPaymentAmountFC = totalWriteoffAmountFC;
      this.totalPaymentAmount = totalWriteoffAmount;
      this.totalPendingAmountFC = totalWriteoffPendingAmountFC;
    });
  }

  // 入金一覧へ遷移する
  public onPaymentNoClick(paymentNo: string){
    this.$router.push(String.format('/cash/Deposit?paymentNo={0}',paymentNo));
  }
  // 発注処理ダイアログの表示
  public showCreatePurchaseOrderDialog(all:boolean = false, bulk:boolean = false) {

  
// ***** 一括発注処理の押下確認 *****
if(all==false && bulk == true){
this.$api.issueGA4trackevent(this.$route.path,'【受注一覧】一括発注処理・押下');
}
    let componentClass = Vue.extend(this.createPurchaseOrder);    
    var router = this.$router;
    this.getCheckedOrders();
    let instance = new componentClass({
        router,
        propsData: {
          checkedOrderItems: bulk ? null : all ? this.allSalesOrderItems() : this.selectedSalesOrderItems(),
          isBulkOrder: bulk,
          checkedOrders: bulk ? this.checkedOrders : null,
          salesOrderItems: this.$refs.salesOrderItems,
          parentMainList: this.$refs.mainList,
          parent: this,
          isItemFlag: false,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }
  // 出荷指示ダイアログの表示
  public showShippingInstructionDialog(all = false, selectedOrder = false){
    var orders = new Array();
    // 業務処理の一括出荷の場合、選択されている受注伝票を取得
    if(selectedOrder == true){
      this.getCheckedOrders();
      if(this.checkedOrders.length == 0){
        this.$api.modal.show('', '受注伝票を選択して下さい。', true, null);
        return;
      }
      orders = this.checkedOrders.filter(obj => obj.state >= Common.OrderStatus.SalesOrderReceiptWaiting && obj.state < Common.OrderStatus.SalesOrderCompleted);
      if(orders.length == 0){
        this.$api.modal.show('', '「出荷処理待ち」か「出荷処理中」の受注伝票を選択してください。', true, null);
        return ;
      }
      if(orders.filter(obj => obj.segment.priceCalculationMethod==Common.PricingTypes.Specific).length>0){
        this.$api.modal.show('', '在庫単価計算が個別法の部門では、明細ごとに処理を行ってください。', true, null);
        return ;
      }
    }
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;
    let componentClass = Vue.extend(this.shippingInstructionDialog);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          execOrder: selectedOrder,
          orderNos: orders.map(obj=>obj.orderNo),
          checkedOrderItems: selectedOrder ? null : all ? this.allSalesOrderItems() : this.selectedSalesOrderItems(),
          parentMainList: this.$refs.mainList,
          salesOrderItems: this.$refs.salesOrderItems,
          tenantSettings: this.tenantSettings, 
          counterpart: parent.counterpart,
          parent: this,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);

  }
  
  // 明細クローズ処理ボタンの活性判別
  public  enabledOrderItemCloseFuncButton(order:Common.SalesOrder):boolean{
    return order.state >= Common.OrderStatus.SalesOrderReceiptWaiting && order.state < Common.OrderStatus.SalesOrderCompleted;
  }
  // 明細クローズ解除処理ボタンの活性判別
  public  enabledOrderItemCloseCancelFuncButton(order:Common.SalesOrder):boolean{
    return order.state >= Common.OrderStatus.SalesOrderReceiptWaiting;
  }
  // 明細クローズ処理
  public async itemClosedQuery(isClose:boolean) {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesOrder;

    var selectedItems:Array<Common.SalesOrderItem>;
    selectedItems = this.selectedSalesOrderItems();
    if(selectedItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
      return;
    }
    var targetItems:Array<Common.SalesOrderItem>;
    targetItems=new Array();
    // クローズ処理：注残あり、クローズ解除処理：クローズ数量あり
    if(isClose == true){
      selectedItems.forEach(item =>{
        if(item.backSalesOrderQuantity > 0) targetItems.push(item);
      });
      if(targetItems.length<1){
        this.$api.modal.show('', '受注残数量のある明細を選択して下さい。', true, null);
        return ;
      }
    }else{
      selectedItems.forEach(item =>{
        if(item.closedQuantity > 0) targetItems.push(item);
      });
      if(targetItems.length<1){
        this.$api.modal.show('', 'クローズ数量のある明細を選択して下さい。', true, null);
        return ;
      }
    }
    return this.$api.modal.showDialog('確認',String.format('選択された受注明細の{0}を0にします。よろしいですか？',isClose?'受注残数量':'クローズ数量'),false).then(()=>{
      var query = new Common.OrderItemCloseQuery();
      query.orderItems = targetItems;
      query.isClose = isClose;
      return this.$api.execute(query).then(res =>{
        //受注残・ステータスが更新されるのでリストを更新する
        (this.$refs.mainList as Components.ListView).onSubmit(res);
        //受注明細タブのリロード
        (this.$refs.salesOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();      
        this.$api.modal.show('処理結果','処理が完了しました。',true,null);
        return true;
      }).catch(()=>{return false;});;
    });
  }

  showSubscriptionDateUpdate:boolean = false;
  subscriptionStartDate: Date = null;
  subscriptionEndDate: Date = null;  
  public showSubscriptionDateUpdateDialog(){

    var selectedItems = this.selectedSalesOrderItems();
    if(selectedItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
      return;
    }
    this.subscriptionStartDate = null;
    this.subscriptionEndDate = null;

    this.showSubscriptionDateUpdate = true;
  }

  public showUpdateDeliveryDateDialog(){
    let componentClass = Vue.extend(this.updateDeliveryDate);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedOrderItems: this.selectedSalesOrderItems(),
          parentMainList: this.$refs.mainList,
          gridVoucherItem: this.$refs.salesOrderItems,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }

  public onSubscriptionDateUpdate(event: any){
    if (this.subscriptionStartDate == null && this.subscriptionEndDate == null){
      this.$api.modal.showDialog('', '契約開始日もしくは契約完了日のいずれかを指定してください。', true, null).then(()=>{
        this.showSubscriptionDateUpdate = true;
      });
      return;      
    }

    var selectedItems = this.selectedSalesOrderItems();
    return this.$api.execute(new Common.OrderItemSubscriptionUpdateQuery(selectedItems,this.subscriptionStartDate,this.subscriptionEndDate)).then(res =>{
      //受注残・ステータスが更新されるのでリストを更新する
      (this.$refs.mainList as Components.ListView).onSubmit(res);
      //受注明細タブのリロード
      (this.$refs.salesOrderItems as Components.GrdVoucherItem).onVoucherNoChanged();      
      this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      return true;
    }).catch(()=>{return false;});;    
  }

  // 個別帳票出力
  public showCustomerReport(isMail: boolean = false){
    this.getCheckedOrders();
    this.checkedOrders.forEach(item =>{ item.designationReportTemplateId = item.counterpart.salesOrderReportTemplateId;});
    if (isMail) (this.$refs.menuBar as Components.ListViewMenuBar).beforeDesignationReportSend(); // 得意先指定帳票メール送信前処理
    else (this.$refs.menuBar as Components.ListViewMenuBar).onDesignationReportGenerate();
  //   if(this.checkedOrders.length > 1){
  //     this.$api.modal.show('', '単一の伝票を選択してください。', true, null);
  //     return ;
  //   }
  //   var templates = (this.$refs.menuBar as Components.ListViewMenuBar).reports;
  //   var template = templates.filter(obj => obj.id == this.checkedOrders[0].counterpart.salesOrderReportTemplateId)[0];
  //   if(template==null){
  //     this.$api.modal.show('', '受注一覧指定帳票が指定されていません。取引先マスタで受注一覧指定帳票を設定してください。', true, null, [new Common.ModalLink('設定の方法はこちら','https://support.s-flow.net/ja/articles/8159389',true)]);
  //     return ;
  //   }
  //   var query = new Common.ReportQuery2(template.queryName, this.checkedOrders);
  //   query.templateId = template.id;
  //   this.$api.download(query); 
  }
  public get orderGrossProfit() : number { return this.isLoading ? null : this.calcOrderGrossProfit;}
  public set orderGrossProfit(value: number) {}
  public calcOrderGrossProfit : number = 0;
  public afterVoucherNoChanged(){
    this.calcOrderGrossProfit = 0;
    var items =  (this.$refs.salesOrderItems as Components.GrdVoucherItem).items as Common.OrderItem[];
    items.forEach(obj => this.calcOrderGrossProfit += obj.calcGrossProfit);
  }
}

